import { useState, useEffect } from 'react';
import butterflyApi from '../ButterflyApi.js';

const HeroesManage = () => {
  const [summary, setSummary] = useState()

  useEffect(() => {
    const load = async () => {
      const data = await butterflyApi.getSummary()
      setSummary(data)
    }
    load()
  }, [])

  if (!summary?.heroes || !Array.isArray(summary.heroes) || summary.heroes.length === 0) {
    return null
  }

  return <div className="px-4 mt-12">
    <div className="mb-4">
      <a href="/manage" className="text-blue-600 underline">Manage</a>
    </div>
    <div className="text-lg font-bold mb-2">주인공 정보</div>
    <div className="flex flex-col gap-4">
      {summary.heroes.map(hero => (
        <div key={hero.heroNo} onClick={() => { window.location.href = `/manage/hero?heroNo=${hero.heroNo}`; }} className="border p-4 rounded shadow-sm bg-gray-50 cursor-pointer">
          <div className="font-semibold text-base mb-1">{hero.name} (No: {hero.heroNo})</div>
          <div className="text-sm mb-1">
            <span className="inline-block mr-2">출생년도: {hero.birthYear}</span>
            <span className="inline-block mr-2">성별: {hero.gender === "M" ? "남아" : hero.gender === "F" ? "여아" : hero.gender}</span>
            <span className="inline-block">지원자No: {hero.supporterNo}</span>
          </div>
          <div className="text-sm mb-1">
            이야기 생성 여부:
            <span className={`ml-2 font-bold ${hero.writingReady ? "text-green-600" : "text-red-600"}`}>
              {hero.writingReady ? "신청함" : "신청 안 함"}
            </span>
          </div>
          {hero.lastViewDatetime && <div className="text-sm mb-1">
            <strong>최근 조회:</strong> {hero.lastViewDatetime}
          </div>}
          {hero.notifyDatetime && <div className="text-sm mb-1">
            <strong>노티일:</strong> {hero.notifyDatetime}
          </div>}
          {<div className="text-sm mb-1">
            <strong>노티 필요 수:</strong> {hero.pendingNotifyCount}
          </div>}
        </div>
      ))}
    </div>
  </div>
}

export default HeroesManage
